/* SHIRTPLUS 19.10.2026 | Canvas-Board 265 „Eigenes Logo auf allen Karten“ | assets/sp-raster-d-handoff.js
   Uebergabe aus der Kollektionsvorschau (Fleecejacken, assets/sp-raster-d.js) an den
   Designer der Produktseite (sections/sp-pdp-neu.liquid + assets/sp-pdp-neu.js).
   Nur aktiv, wenn der Kunde gerade aus der Uebersicht kommt: sessionStorage „sprd-pick“
   (gesetzt beim Klick auf Bild/Titel/„Mit Logo gestalten“) passt zur aufgerufenen
   Produkt-URL und ist hoechstens 2 Stunden alt.
   1. Vor dem Start von sp-pdp-neu.js (dieses Skript steht davor, beide „defer“): die in
      der Uebersicht gezeigte Farbe als Startfarbe in [data-spn-data] eintragen.
   2. Nach dem Start (und nach dem Aris-Optionssatz): im Schritt „Logos & Veredelung“
      Logo 1 auf Stick + Position (Brust links/rechts/Ruecken wie in der Uebersicht)
      stellen und das Logo aus der Uebersicht (sessionStorage „sprd-logo-orig“, sonst
      die PNG-Vorschau „sprd-logo-v1“) per DataTransfer in das Datei-Feld legen – der
      Logo-Check (assets/sp-pdp-probe.js) laeuft dann wie bei einem normalen Upload.
   3. Hinweis ueber den Logos: „Dein Logo aus der Übersicht ist schon geladen – ändern?“
   sp-pdp-neu.js bleibt unveraendert; die Datei bleibt im Browser, bis der Kunde bestellt. */
(function () {
  'use strict';
  if (window.__sprdHandoff) return;
  window.__sprdHandoff = true;
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sdel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function parse(k) { try { return JSON.parse(sget(k) || 'null'); } catch (e) { return null; } }
  var pick = parse('sprd-pick');
  if (!pick || pick.v !== 1 || !pick.url || Date.now() - (pick.ts || 0) > 7200000) return;
  var path = decodeURIComponent(location.pathname).replace(/\/+$/, '');
  var want = decodeURIComponent(String(pick.url)).replace(/\/+$/, '');
  if (path !== want) return;
  var root = document.querySelector('[data-spn-root]');
  if (!root) return;
  var EN = /^en/i.test(document.documentElement.lang || '') || /^\/en\//.test(location.pathname);
  function T(de, en) { return EN ? en : de; }

  /* 1. Startfarbe */
  var dataEl = root.querySelector('[data-spn-data]');
  if (dataEl && pick.c && !root.dataset.spnReady) {
    try {
      var data = JSON.parse(dataEl.textContent);
      var hit = (data.colors || []).some(function (c) { return c && c.name === pick.c; });
      if (hit && data.initialColor !== pick.c) {
        data.initialColor = pick.c;
        dataEl.textContent = JSON.stringify(data);
      }
    } catch (e) {}
  }

  /* 2. Logo vorladen */
  function toBlob(du) {
    var m = /^data:([^;,]+)(;base64)?,(.*)$/.exec(du || '');
    if (!m) return null;
    var bin = m[2] ? atob(m[3]) : decodeURIComponent(m[3]), a = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) a[i] = bin.charCodeAt(i);
    return new Blob([a], { type: m[1] });
  }
  function logoFile() {
    var o = parse('sprd-logo-orig'), p = parse('sprd-logo-v1'), b;
    if (o && o.v === 1 && o.d && p && o.ts === p.ts && (b = toBlob(o.d))) return new File([b], o.n || 'logo', { type: o.t || b.type });
    if (p && p.v === 1 && p.p && (b = toBlob(p.p))) return new File([b], String(p.n || 'logo').replace(/\.[^.]+$/, '') + '.png', { type: 'image/png' });
    return null;
  }
  var file = logoFile();
  if (!file || typeof DataTransfer === 'undefined') { sdel('sprd-pick'); return; }

  function logosBox() { return root.querySelector('[data-spn-logos]'); }
  function card1() { var b = logosBox(); return b ? b.querySelector('.spn-logo') : null; }
  function ready() {
    var b = logosBox();
    if (!root.spnState || !b || !card1()) return false;
    /* mit Aris-Optionssatz: warten, bis er eingelesen ist (Box wieder bedienbar) */
    if (document.querySelector('.app-avis-product-options-block') && b.style.opacity !== '') return false;
    return true;
  }
  function clickBy(sel, re) {
    var c = card1(); if (!c) return false;
    var bs = c.querySelectorAll(sel);
    for (var i = 0; i < bs.length; i++) {
      var t = (bs[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (re.test(t)) {
        if (bs[i].disabled) return false;
        if (bs[i].getAttribute('aria-pressed') !== 'true') bs[i].click();
        return true;
      }
    }
    return false;
  }
  function note() {
    var b = logosBox();
    if (!b || root.querySelector('.sprd-hand')) return;
    if (!document.getElementById('sprd-hand-css')) {
      var css = document.createElement('style'); css.id = 'sprd-hand-css';
      css.textContent = '.sprd-hand{display:flex;flex-wrap:wrap;align-items:center;gap:4px 8px;margin:0 0 16px;padding:12px 16px;border-radius:12px;background:#E6F8F2;color:#111111;font-size:16px;line-height:24px}' +
        '.sprd-hand button{padding:0;border:0;background:none;font:inherit;color:#111111;cursor:pointer;text-decoration:underline;text-decoration-color:#78E6D0;text-decoration-thickness:2px;text-underline-offset:4px}' +
        '.sprd-hand button:hover{color:#0B6B5A}.sprd-hand button:focus-visible{outline:2px solid #111111;outline-offset:2px}';
      document.head.appendChild(css);
    }
    var n = document.createElement('p');
    n.className = 'sprd-hand';
    n.setAttribute('role', 'status');
    var s = document.createElement('span');
    s.textContent = T('Dein Logo aus der Übersicht ist schon geladen –', 'Your logo from the overview is already loaded –');
    var a = document.createElement('button');
    a.type = 'button';
    a.textContent = T('ändern?', 'change?');
    a.addEventListener('click', function () {
      var c = card1(), fi = c && c.querySelector('label.spn-upl input[type="file"]');
      if (fi) fi.click();
    });
    n.appendChild(s); n.appendChild(a);
    b.parentNode.insertBefore(n, b);
  }
  function apply() {
    var st = root.spnState, lg = st && st.logos && st.logos[0];
    if (!lg || lg.file || lg.fileUrl || st.later) { sdel('sprd-pick'); return; } /* Kunde hat schon selbst etwas gewaehlt */
    clickBy('.spn-seg__btn', /^(Stick|Embroidery)\b/i);
    var pos = pick.pos === 'r' ? /^Brust rechts|^Right chest/i : (pick.pos === 'b' ? /^R(ü|ue)cken(?! komplett)|^Back\b/i : /^Brust links|^Left chest/i);
    clickBy('.spn-pill', pos);
    var c = card1(), fi = c && c.querySelector('label.spn-upl input[type="file"]');
    if (!fi) return;
    var dt = new DataTransfer();
    dt.items.add(file);
    fi.files = dt.files;
    fi.dispatchEvent(new Event('change', { bubbles: true }));
    sdel('sprd-pick');
    note();
  }
  var t0 = Date.now();
  (function wait() {
    if (ready()) return apply();
    if (Date.now() - t0 > 20000) return;
    setTimeout(wait, 250);
  })();
})();
